import { useMemo } from "react";
import { useOrderLoader } from "services/orders/OrderLoaderContext";

export const useSurveillanceMode = (): boolean => {
  const { order } = useOrderLoader();
  return useMemo(() => !!order?.surveillance, [order]);
};
